import { useContext, useState, useEffect } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import { containsXss } from "../../../utils/security/XssFilter";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import { IAM_PATH, IAM_SERVER_SERVICE_GROUP } from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from '../../../utils/modal/DetailModal.module.css';
// import { ConstructionTwoTone } from "@mui/icons-material";


/**
 * 그룹 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const GroupRegisterModal = ({ update, selectedServiceId, groupData, selectedGroupId }) => {
    const { closeModal } = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    // const [isDuplicateChecked, setIsDuplicateChecked] = useState(false); // 중복 확인 완료 여부

    const [formData, setFormData] = useState({
        // linkServiceId: selectedServiceId,
        groupName: '',
        groupDescription: '',
        parentGroupId: ''
    });

    useEffect(() => {
        // selectedGroupId가 "0"이 아니면 parentGroupId에 자동 할당
        if (selectedGroupId && selectedGroupId !== "0") {
            setFormData(prev => ({
                ...prev,
                parentGroupId: selectedGroupId
            }));
        }
        // 만약 최상위라면 빈값
        else {
            setFormData(prev => ({
                ...prev,
                parentGroupId: ""
            }));
        }
    }, [selectedGroupId]);

    const parentOptions = (groupData || [])
        .filter(item => item.title !== '미지정' && item.key !== '0')
        .map(item => ({
            id: item.key,
            name: item.title
        }));

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    // 서비스스 등록 요청 API
    const handleRegister = () => {
        for (let key in formData) {
            if (key !== 'parentGroupId' && formData[key] === '' && key !== 'groupDescription') {
                setIsNull(true);
                return;
            } else if (containsXss(formData[key])) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);

        let newFormData = { ...formData };
        if (selectedGroupId && selectedGroupId !== "0") {
            newFormData.parentGroupId = selectedGroupId;
        }

        const params = {
            // linkServiceId: newFormData.linkServiceId,
            groupName: newFormData.groupName,
            // groupDescription: newFormData.groupDescription,
            // parentGroupId: newFormData.parentGroupId !== '' ? Number(newFormData.parentGroupId) : 0
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_GROUP + "/create";

        axios.post(url, params)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
                console.error(e)
            });
    }

    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>그룹 명</p>
                    <input className={styles.layer__listInput}
                        type={"text"}
                        name={"groupName"}
                        value={formData.groupName}
                        onChange={handleChange}
                        maxLength={30}
                    />
                </li>
                {/* <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>설명</p>
                    <textarea
                        className={styles.layer__listInput}
                        name={"groupDescription"}
                        value={formData.groupDescription}
                        onChange={handleChange}
                        rows={4} // 원하는 줄 수 조절 가능
                    />
                </li> */}
                {/* <li className={styles.layer__list}>
                    <p lang={"ko"} className={styles.layer__listTit}>상위 그룹</p>
                    {selectedGroupId !== "0" ? (
                        // 하위 뎁스 추가 상황 → 부모 선택 불가, 고정
                        <input
                        className={styles.layer__listInput}
                        type="text"
                        value={parentOptions.find(opt => opt.id === selectedGroupId)?.name || ''}
                        readOnly
                        disabled
                        />
                    ) : (
                        // 최상위 추가 상황 → 선택 가능
                        <select
                        className={styles.layer__listInput}
                        name="parentGroupId"
                        value={formData.parentGroupId || ''}
                        onChange={handleChange}
                        >
                        <option value="">:: 상위 그룹 선택 ::</option>
                        <option value="0">루트 그룹</option>
                        {parentOptions.map(opt => (
                            <option key={opt.id} value={opt.id}>
                            {opt.name}
                            </option>
                        ))}
                        </select>
                    )}
                </li> */}
            </ul>

            {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
            <button className={styles.layer__saveBtn} onClick={handleRegister}>등록</button>
        </div>
    )
}